// What an import of a result file into this analysis came to (libra #1930),
// for any screen that posts one through useSomaticImport: the confirm step
// when the file names another sample, the server's sentence when it was
// refused, and nothing once it went in.
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

export const ImportOutcome = ({ outcome, busy, onConfirm, onCancel }) => {
  const asking = outcome?.state === 'confirm_other_sample'
  const refused = outcome?.state === 'refused' || outcome?.state === 'error'
  return (
    <>
      {refused && (
        <Alert severity="warning" onClose={onCancel} data-testid="import-refused">
          {outcome.text}
        </Alert>
      )}
      <Dialog open={asking} onClose={busy ? undefined : onCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Import a file for another sample?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" data-testid="import-confirm-text">
            {outcome?.text}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Import it anyway only if the file belongs to this patient, for example when the testing laboratory named the
            sample differently.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm} disabled={busy} data-testid="import-confirm">
            Import anyway
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

ImportOutcome.propTypes = {
  outcome: PropTypes.shape({ state: PropTypes.string, text: PropTypes.string }),
  busy: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

ImportOutcome.defaultProps = { outcome: null, busy: false }

export default ImportOutcome
